export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәтті"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қате"])}
}